import React, {Component, ReactElement, ReactNode} from "react";
import {CellFactory} from "./cells/CellFactory";
import './ResultTable.scss';
import {
    Container,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, Tooltip, Typography
} from '@mui/material';
import {DisplayProperties} from '../content/displayproperties/DisplayProperties';
import {BaseCell} from './cells/BaseCell';
import {ColumnDetails} from '../content/GameContext';

export interface ResultTableProperties {
    columns: ColumnDetails[];
    widths: number[];
    rows: DisplayProperties[][];
}

export default class ResultTable extends Component<ResultTableProperties> {
    messagesEndRef = React.createRef<HTMLTableRowElement>();

    private getTitleRow(): ReactElement {
        return <TableRow>
            {this.props.columns.map((item) => {
                return <Tooltip arrow
                                title={
                                    <React.Fragment>
                                        <Typography color="inherit">{item.detailedTitle}</Typography>
                                        {item.message}
                                    </React.Fragment>
                                }>
                    <TableCell
                        key={item.title}
                        align={'center'}
                        sx={{color: "primary.main", padding: 0, borderBottom: 1, fontWeight: "bold", userSelect: "none"}}
                    >
                        {item.title}
                    </TableCell>
                </Tooltip>;
            })}
        </TableRow>;
    }

    private convertRowsToCells(): ReactElement[] {
        return this.props.rows.map(
            (row) => {
                const key = row.map(property => property.key).join('_');
                return <TableRow key={key}>
                    {
                        row.map(prop => {
                            let cellType = CellFactory.GetCellTypeFromDisplayPropertyType(prop.type);
                            return <BaseCell key={prop.key} content={cellType} display={prop}/>;
                        })
                    }
                </TableRow>;
            }
        );
    }

    private scrollToBottom = () => {
        this.messagesEndRef?.current?.scrollIntoView({behavior: 'auto'});
    };

    override componentDidUpdate(): void {
        this.scrollToBottom();
    }

    override render(): ReactNode {
        return <TableContainer>
            <Table stickyHeader sx={{borderSpacing: 1}}>
                <colgroup>
                    {this.props.widths.map((width, i) => <col key={"colWidth_" + i} width={`${width}%`}/>)}
                </colgroup>
                <TableHead>
                    {this.getTitleRow()}
                </TableHead>
                <TableBody>
                    {this.convertRowsToCells()}
                    <tr ref={this.messagesEndRef}/>
                </TableBody>
            </Table>
        </TableContainer>
    }
}
